import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setPageTitle } from '../../utils/title';
import {
  SecurityIcon,
  InfrastructureIcon,
  FinOpsIcon,
  ComplianceIcon,
  AISecurityIcon,
} from '../../components/icons';
import Breadcrumb from '../../components/Breadcrumb';
import './Solutions.scss';

const Solutions = () => {
  useEffect(() => {
    setPageTitle('Solutions');
  }, []);

  const solutions = [
    {
      id: 'security',
      title: 'Cloud Infrastructure Security',
      icon: <SecurityIcon />,
      path: '/solutions/security',
      description:
        'Design and implement secure cloud infrastructure that keeps your data protected and systems compliant with rigorous regulatory standards (SOC 2, HIPAA, ISO, GDPR, ...).',
    },
    {
      id: 'infrastructure',
      title: 'Cloud Infrastructure for Systems and Apps',
      icon: <InfrastructureIcon />,
      path: '/solutions/infrastructure',
      description:
        'Leverage AWS services to host your applications, ensuring optimal cost, operational excellence, security, and efficiency.',
    },
    {
      id: 'finops',
      title: 'FinOps – Cost Management in the Cloud',
      icon: <FinOpsIcon />,
      path: '/solutions/finops',
      description:
        'Optimize your AWS costs by analyzing cloud usage, identifying opportunities to reduce waste, and implementing tailored strategies to maximize performance while minimizing expenses.',
    },
    {
      id: 'compliance',
      title: 'IT Compliance Solutions (GRC)',
      icon: <ComplianceIcon />,
      path: '/solutions/compliance',
      description:
        'Establish and implement comprehensive IT compliance programs that meet regulatory requirements and industry standards (SOC 2, HIPAA, NIST, ISO, GDPR, ...).',
    },
    {
      id: 'ai-security',
      title: 'Secure AI Deployment',
      icon: <AISecurityIcon />,
      path: '/solutions/ai-security',
      description:
        'Implement secure and privacy-enhanced AI solutions, including LLMs and custom models, with robust guardrails and operational governance.',
    },
  ];

  return (
    <>
      <Breadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Solutions', path: '/solutions' },
        ]}
      />
      <section className="page-header">
        <div className="container">
          <h1 className="page-header__title">Solutions</h1>
          <p className="page-header__subtitle">
            Explore our full range of cloud, security, compliance, and AI/ML solutions for modern
            businesses.
          </p>
        </div>
      </section>
      <section className="section section--light">
        <div className="container">
          <div className="row">
            {solutions.map(solution => (
              <div className="col col-md-6" key={solution.id}>
                <div className="card">
                  <h3
                    className="card__title"
                    style={{ display: 'flex', alignItems: 'center', gap: 12 }}
                  >
                    <span style={{ fontSize: 28 }}>{solution.icon}</span>
                    <Link to={solution.path}>{solution.title}</Link>
                  </h3>
                  <p className="card__description">{solution.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Solutions;
